import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\CookieConsentController::save
* @see app/Http/Controllers/CookieConsentController.php:21
* @route '/cookie-consent'
*/
export const save = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: save.url(options),
    method: 'post',
})

save.definition = {
    methods: ["post"],
    url: '/cookie-consent',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CookieConsentController::save
* @see app/Http/Controllers/CookieConsentController.php:21
* @route '/cookie-consent'
*/
save.url = (options?: RouteQueryOptions) => {
    return save.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CookieConsentController::save
* @see app/Http/Controllers/CookieConsentController.php:21
* @route '/cookie-consent'
*/
save.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: save.url(options),
    method: 'post',
})

const cookieConsent = {
    save: Object.assign(save, save),
}

export default cookieConsent